// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconDocs = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M2.926 7.185.667 11.031V3.952c0-.893.73-1.619 1.63-1.619h2.992c.433 0 .848.17 1.153.473l.675.67c.306.304.72.474 1.154.474h2.99c.898 0 1.629.726 1.629 1.619v.81H4.334c-.58 0-1.115.306-1.408.804zm.703.408a.82.82 0 0 1 .705-.403H14.52a.81.81 0 0 1 .703 1.22l-2.853 4.857a.81.81 0 0 1-.702.4H1.482a.81.81 0 0 1-.703-1.22L3.631 7.59z'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconDocs)
const Memo = memo(ForwardRef)
export default Memo
